import GatsbyImage from 'gatsby-image';
import styled from 'styled-components';
import { mobileFirstMedia as media } from '../../../config/theme';
import { Link as LinkBase } from 'gatsby';

export const Grid = styled.div`
  display: grid;
  grid-gap: 40px;
  grid-template-columns: minmax(0, 1fr);
  position: relative;

  @media (${media.xs}) {
    grid-template-columns:
      minmax(25px, 1fr) minmax(50px, 350px) minmax(50px, 350px)
      minmax(25px, 1fr);
  }

  @media (${media.m}) {
    grid-gap: 60px;
    grid-template-columns: 300px minmax(0, 1fr);
  }
`;

export const Aside = styled.aside`
  @media (${media.xs}) {
    grid-column: 2 / 4;
  }

  @media (${media.m}) {
    grid-column: 1 / 2;
    align-self: start;
    position: sticky;
    top: 25px;
  }
`;

export const Navigation = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
`;

export const NavigationItem = styled.li`
  margin: 0;
`;

export const Link = styled(LinkBase)`
  display: flex;
  align-items: center;
  padding: 0.6em 0.8em;
  color: white;
  transition: background-color 300ms ease-in-out;
  background-color: hsl(210, 2%, 25%);

  &:nth-of-type(odd) {
    background: hsl(210, 2%, 27%);
  }

  &:hover,
  &.active {
    background: ${({ theme }) => theme.colors.primary};
  }
`;

export const IconWrapper = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  color: ${({ theme }) => theme.colors.text};
  margin-right: 1em;
`;

export const Content = styled.div`
  overflow: hidden;
  @media (${media.xs}) {
    grid-column: 2 / 4;
  }

  @media (${media.m}) {
    grid-column: 2 / 3;
  }
`;

export const BackgroundImageArea = styled.div`
  margin: 0 -25px;
  filter: drop-shadow(rgba(0, 0, 0, 0.2) 0px 0px 20px);

  @media (${media.xs}) {
  }

  @media (${media.s}) {
  }

  @media (${media.m}) {
  }
`;

export const BackgroundImage = styled(GatsbyImage)`
  height: 100%;
  clip-path: polygon(
    var(--cropSize) 0,
    100% 0,
    100% 100%,
    0 100%,
    0 var(--cropSize)
  );
`;

export const Image = styled(GatsbyImage)`
  display: none;

  @media (${media.m}) {
    height: 450px;
    display: block;
    margin-top: 40px;
    clip-path: polygon(
      100% 0,
      100% calc(100% - calc(var(--cropSize) / 1.5)),
      calc(100% - calc(var(--cropSize) / 1.5)) 100%,
      0 100%,
      0 0
    );
  }
`;
